import React, { ReactElement } from 'react'

export const DashboardChoose = (): ReactElement => (
    <svg x='0px' y='0px' viewBox='0 0 24 24'>
        <g>
            <path d='M13.7,12.6c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1h0.6V12.6z' />
            <path
                fill='white'
                d='M13.1,19.3l-2.7-0.6l2.3,2.3c0.1,0,0.1,0,0.1,0.1h3.9l0.5-2.9c0-0.3-0.1-0.5-0.3-0.7l-2.2-1.1h-1.1v-1.3h-0.6
                V19.3z'
            />
            <path
                fill='#424242'
                d='M11.8,12.7H5V2.2h10.5v10.5h-0.6v0.5l0,1h0.6c0.8,0,1.5-0.7,1.5-1.5V2.2c0-0.8-0.7-1.5-1.5-1.5H5
                c-0.8,0-1.5,0.7-1.5,1.5v10.5c0,0.8,0.7,1.5,1.5,1.5h6.8v-1V12.7z'
            />
            <path
                fill='#424242'
                d='M18.9,14.4l-3-1.5l-0.8-0.1l0-0.2l0-1.5v-0.8l0-1.4c0-1-0.6-2-1.6-2.3c-1.6-0.5-3.1,0.7-3.1,2.2v1.5v0.8v1.5
                v0.8v3.1C8.3,16,8.5,16,8.2,16c-0.5,0-0.9,0.2-1.3,0.5l-1.4,1.4l4.8,4.8c0.4,0.4,1,0.6,1.5,0.6h5.9c0.9,0,1.7-0.7,1.8-1.6l0.8-4.4
                C20.7,16.2,20,14.9,18.9,14.4z M18.6,17.1l-0.7,4.4h-5.9c-0.1,0-0.1-0.1-0.2-0.1l-3.5-3.5l4,0.8v-6.2v-2.2V8.8
                c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.5v2.2v1.9h1.7l3.2,1.6C18.5,16.3,18.7,16.7,18.6,17.1z'
            />
        </g>
    </svg>
)
